import { render, staticRenderFns } from "./LanguageDropdown.vue?vue&type=template&id=de3ed738&scoped=true"
import script from "./LanguageDropdown.vue?vue&type=script&lang=ts"
export * from "./LanguageDropdown.vue?vue&type=script&lang=ts"
import style0 from "./LanguageDropdown.vue?vue&type=style&index=0&id=de3ed738&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de3ed738",
  null
  
)

export default component.exports